import { createSelector } from 'reselect';
import _ from 'lodash';

import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';

export const getServingSitesOptions = createSelector(
  state => _.get(state, 'PointOfSaleState.common.servingSites'),
  servingSites =>
    _.isEmpty(servingSites)
      ? []
      : _.chain(servingSites)
          .sortBy('Id')
          .map(({ Id, Description }) => ({
            key: Id,
            value: Id,
            text: `${Id} ${Description}`,
          }))
          .value()
);

export const getSelectedSiteDetails = state =>
  _.get(state, 'PointOfSaleState.dateAndSiteDetails.selectedSiteDetails', {});

export const getSelectedSiteAlternateProvisionTypeId = state => {
  return _.get(getSelectedSiteDetails(state), 'AlternateProvisionTypeId');
};

export const getSelectedSiteDetailsSiteId = state => {
  return _.get(getSelectedSiteDetails(state), 'Id');
};

export const isSelectedSiteCEP = state => {
  return (
    _.get(getSelectedSiteDetails(state), 'AlternateProvisionTypeEnum') ===
    AlternateProvisionTypeEnum.CEP
  );
};

export const getSelectedDate = state =>
  _.get(state, 'PointOfSaleState.dateAndSiteDetails.date');

export const getSelectedCepType = state =>
  _.get(state, 'PointOfSaleState.dateAndSiteDetails.cepType', {});

export const getSelectedCepTypeId = state =>
  _.get(getSelectedCepType(state), 'Id');

export const getIsSetDateAndSitePopupOpen = state =>
  _.get(state, 'PointOfSaleState.dateAndSiteDetails.isSetDateAndSitePopupOpen');



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/state/selectors.js